import {
  storage,
  device,
  proxy,
  token,
  converter,
  spa,
  performance,
  webMaxAPI,
  ui,
  navigation,
  gray
} from '../../web'

import { _default } from '../ctx'

export function registerApi() {
  globalThis.MaxAPI = webMaxAPI

  // ui
  _default.register('ui.toast', ui.toast)
  _default.register('ui.loading', ui.loading)
  // 新增：全局浮层
  _default.register('ui.showOverlay', ui.showOverlay)
  _default.register('ui.hideOverlay', ui.hideOverlay)
  // device
  _default.register('device.hasSubScreen', device.hasSubScreen)
  _default.register('device.getSerialNumber', device.getSerialNumber)
  _default.register('device.md5', device.md5)
  _default.register('device.sha256', device.sha256)
  _default.register('device.des', device.des)
  _default.register('device.decryptDES', device.decryptDES)
  _default.register('device.desIV', device.desIV)
  _default.register('device.decryptDESIV', device.decryptDESIV)
  _default.register('device.restart', device.restart)

  _default.register('setNavigationBarTitle', navigation.setNavigationBarTitle)

  // 执行优先度相对较低的任务
  _default.register('idleCallback', device.idleCallback)

  // storage
  _default.register('localStorage.addListener', storage.addListener)
  _default.register('localStorage.removeListener', storage.removeListener)

  // token
  _default.register('addTokenListener', token.addTokenListener)
  _default.register('removeTokenListener', token.removeTokenListener)


  // proxy
  _default.register('proxy.params', proxy.params)

  // converter
  _default.register('converter.qrCode', converter.qrCode)
  _default.register('converter.previewPrint', converter.previewPrint)

  // spa
  _default.register('clearSubPageCache', spa.clearSubPageCache)
  _default.register('onClearSubPageCache', spa.onClearSubPageCache)

  // debug
  _default.register('performance.beginSession', performance.beginSession)
  _default.register('performance.endSession', performance.endSession)

  // gray
  _default.register('gray.setTagValue', gray.setTagValue)
}
